import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { audios, playByName, playByGeometryName } from './audios'

const useStore = create(
  devtools(
    (set) => ({
      orbit: {
        enabled: true,
      },
      toggleOrbit: () => set((state) => ({
        orbit: { enabled: !state.orbit.enabled },
      })),
    
      transforms: {},
      setTransforms: ({ id, key, value }) => set((state) => {
        const objectTransform = { ...state.transforms[id], [key]: value }
        const transforms = { ...state.transforms, [id]: objectTransform }

        return { ...state, transforms }
      }),

      audios,
      playByName,
      playByGeometryName,
    }),
  ),
)

export default useStore
